import SidebarLayout from "../../../../layouts/SidebarLayout";
import ManageTicketForm from "./_components/ManageTicketForm";

const ManageTicket = () => {
  return (
    <SidebarLayout title="Ticket Management">
      <ManageTicketForm key={2} />
    </SidebarLayout>
  );
};

export default ManageTicket;
